<dx-select-box [items]="validKIPrompts"
               [(value)]="pimField.systemKey"
               displayExpr="name"
               valueExpr="id"
               (onValueChanged)="onSelectionChanged()">
</dx-select-box>
<dx-button icon="plus"
           stylingMode="contained"
           (onClick)="openPromptEditor()">
</dx-button>
<dx-button icon="edit"
           *ngIf="checkIfPromptSelected()"
           stylingMode="contained"
           (onClick)="openPromptEditorToEdit()">
</dx-button>
<dx-button icon="trash"
           *ngIf = "checkIfPromptSelected()"
           stylingMode="contained"
           (onClick)="deleteCurrentPrompt()">
</dx-button>

<dx-popup [(visible)]="isPopupVisible"
          [showTitle]="true"
          title="Prompt Editor"
          [hideOnOutsideClick]="true">
  <dxi-popup-toolbar-item toolbar="bottom"
                    name="addRowButton"
                    location="after"
                    widget="dxButton"
                    [options]="{ text:'Abbrechen', onClick: onCancelEdit }">
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item toolbar="bottom"
                    location="after"
                    widget="dxButton"
                    [options]="{ text:'Speichern', type:'default', onClick: onSaveEdit }">
  </dxi-popup-toolbar-item>
  <aiprompt-editor [prompt]="editedPrompt"></aiprompt-editor>


</dx-popup>
